import { useSelector } from 'react-redux';

import { getRepoCommitsState } from 'src/redux/repo-commits/selectors';
import {
  getBranchViewDestinationBranchHash,
  getBranchViewDestinationRepoName,
  getBranchViewSourceBranchHash,
  getBranchViewSyncStrategies,
} from 'src/redux/repository/branch/branch-redux';
import { useParams } from 'src/router/hooks';
import { RepositoryCommitListProps } from 'src/sections/repository/components/commit-list';
import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';
import urls from 'src/urls/commit';

import { useFetchCommitActions } from '../../../components/commit-list/hooks/use-branch-commit';

export const useBranchCommitListDetails = (): RepositoryCommitListProps => {
  const { commits, hasError, isLoading, nextUrl } =
    useSelector(getRepoCommitsState);
  const { ref: branchName } = useParams<{ ref: string }>();
  if (!branchName) {
    throw Error('Branch commit list details must contain a branch name');
  }

  const sourceHash = useSelector(getBranchViewSourceBranchHash) || '';
  const destHash = useSelector(getBranchViewDestinationBranchHash) || '';
  const repositoryFullSlug = useSelector(getCurrentRepositoryFullSlug) || '';
  const destRepoFullSlug = useSelector(getBranchViewDestinationRepoName) || '';
  const syncStrategies = useSelector(getBranchViewSyncStrategies);

  const commitsUrl = urls.api.internal.specCommitsApiUrl(
    repositoryFullSlug,
    sourceHash,
    destRepoFullSlug,
    destHash
  );
  const { retryFetchBranchCommits, fetchMoreBranchCommits } =
    useFetchCommitActions();

  return {
    commits: commits || [],
    hasError,
    isLoading,
    hasMore: !!nextUrl,
    syncStrategies,
    retryAction: () => retryFetchBranchCommits(commitsUrl),
    fetchMoreAction: () => fetchMoreBranchCommits(nextUrl || ''),
  };
};
